<template>
    <div
        class="button-container is-flex is-flex-direction-row is-justify-content-center"
        :class="{
            'inactive':!enabled,
        }"
        @click="redirectToOrderPage"
        role="button">
        <span class="is-center">Bestellen</span>
    </div>
</template>

<script>

export default {
    name: 'PublicMenuPlanOrderButton',
    props: [
        'enabled'
    ],
    methods: {
        async redirectToOrderPage() {
            if (!this.enabled) {
                return
            }
            await this.$router.push('/speiseplan')
            this.$router.go(0)
        },
    }
}
</script>

<style lang="scss" scoped>
.error {
    color: $warning-color;
    bottom: -25px;
    width: 100%;
}

.button-container {
    border: 2px solid $primary;
    border-radius: 500px;
    padding: 10px 16px;
    width: 100%;
    cursor: pointer;

    &.inactive {
        border: 2px solid $dark-grey;
        opacity: .4;
        cursor: default;
    }
}

.iPhone {
    .button-container {
        padding: 6px 16px;
    }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type=number] {
    -moz-appearance: textfield;
}

</style>
